import { render, staticRenderFns } from "./qxzn.vue?vue&type=template&id=6143d504&scoped=true&"
import script from "./qxzn.vue?vue&type=script&lang=js&"
export * from "./qxzn.vue?vue&type=script&lang=js&"
import style0 from "./qxzn.vue?vue&type=style&index=0&id=6143d504&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6143d504",
  null
  
)

export default component.exports